import * as React from "react";
import { OrderedCalendar } from "burde";
import * as cn from "classnames/bind";
import * as moment from "moment";
import * as styles from "./list.css";

const cx = cn.bind(styles);

const alignRightCn = () =>
    cx({
        rightAligned: true,
    });

interface ICalendarRowProps {
    calendars: OrderedCalendar[];
    download: string;
}

const CalendarRow = (props: ICalendarRowProps): React.ReactElement => {
    const { calendars, download } = props;

    return (
        <tbody>
            {calendars.map(
                ({
                    calendarId,
                    userEmail,
                    layout,
                    externalStatus,
                    orderDate,
                    culture,
                }) => (
                    <tr key={calendarId}>
                        <td>{calendarId}</td>
                        <td>{userEmail}</td>
                        <td>
                            {moment
                                .utc(orderDate)
                                .local()
                                .format("YYYY-MM-DD HH:mm")}
                        </td>
                        <td>{layout}</td>
                        <td>{culture}</td>
                        <td>{externalStatus}</td>
                        <td className={alignRightCn()}>
                            <a
                                href={`/api/pdf/Download?calendarId=${calendarId}`}>
                                {download}
                            </a>
                        </td>
                    </tr>
                ),
            )}
        </tbody>
    );
};

export { CalendarRow };
